import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import '../scss/app.scss';
import changeStyles from './lib/change-styles';
import setupTest from './lib/setup-test';
import setupAnimatedTest from './lib/setup-animated-test';
import qs from './lib/qs';
import deviceDetection from './lib/detect-device';

Sentry.init({
  dsn: 'https://6bc834b2b80847539956bbe6be536663@sentry.io/4361155',

  // To set your release version
  release: `my-project-name@${process.env.npm_package_version}`,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.NODE_ENV,
});

const OFCA_PANEL_ID = 261;
const CITC_PANEL_ID = 235;
const VIRGIN_PANEL_ID = 1013;
const STG_WEB_AGENTS_DEMO = 1025;

const targetSet = {
  [CITC_PANEL_ID]: 'offnet-citc',
  [OFCA_PANEL_ID]: 'ofca-web-datapacket',
  [VIRGIN_PANEL_ID]: 'offnet-virgin-100g',
  // Emulate virgin for test panel so we can test ingestion to STG
  [STG_WEB_AGENTS_DEMO]: 'offnet-virgin-100g',
}[qs('panel-id')];

const options = {
  global: {
    targetSet,
    useTestServersInParallel: true,
  },
  download: {},
  upload: {},
  ingestion: {
    ingestionApi: process.env.INGESTION_API,
    panelId: parseInt(qs('panel-id'), 10),
  },
};

if (qs('test-server')) {
  options.global.testServers = [qs('test-server')];
}

// OFCA
if (parseInt(qs('panel-id'), 10) === OFCA_PANEL_ID) {
  options.global.warmupDuration = 6000;
  options.download.duration = 9000;
  options.upload.duration = 9000;
}

// CITC
if (parseInt(qs('panel-id'), 10) === CITC_PANEL_ID) {
  options.global.wsTestServerPort = location.protocol === 'https:' ? 443 : 6501;
}

if (qs('test') === 'animated') {
  setupAnimatedTest(options);
} else {
  setupTest(options);
}

changeStyles();

deviceDetection.getDevice().then((device) => {
  options.ingestion.device = device;
});



// WEBPACK FOOTER //
// ./src/js/main.js